export * from "./pointsActions/purchase";
export * from "./pointsActions/refund";
export * from "./pointsActions/codeRedemption";
export * from "./pointsActions/codeActivation";
export * from "./pointsActions/codeCancellation";
export * from "./pointsActions/userTransfer";
export * from "./pointsActions/depositProgramBucket";
export * from "./pointsActions/taskerReward";
export * from "./pointsActions/incentivesProgramAward";
import { convertTimestampToLuxonOrDefaultNow } from "../utils/convertTimestampToLuxonOrDefaultNow";
export const POINTS_ACTION_LABELS = {
    purchase: "Purchase",
    refund: "Refund",
    codeRedemption: "Code Redemption",
    userTransfer: "User Transfer",
    codeActivation: "Code Activation",
    codeCancellation: "Code Cancellation",
    depositProgramBucket: "Deposit Program Bucket",
    taskerReward: "Tasker Reward",
    taskerRefund: "Tasker Refund",
    incentivesProgramAward: "Incentives Program Award",
};
export const createPointsAction = (data) => {
    const pointsAction = data;
    assertPointsAction(pointsAction, "save");
    return pointsAction;
};
export const assertPointsAction = (data, mode = "load") => {
    if (!data || typeof data !== "object") {
        throw new Error("PointsAction must be an object");
    }
};
export const createPointsActionConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(pointsAction) {
        assertPointsAction(pointsAction, "save");
        const data = {
            ...pointsAction,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(pointsAction.createdAt),
            modifiedAt: convertToFirestoreTimestampOrDefaultServerTime(pointsAction.modifiedAt),
        };
        if (pointsAction.type === "purchase") {
            data.typeMeta.purchasedAt =
                convertToFirestoreTimestampOrDefaultServerTime(pointsAction.typeMeta.purchasedAt);
        }
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        const pointsAction = {
            ...data,
            id: snapshot.id,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            modifiedAt: convertTimestampToLuxonOrDefaultNow(data.modifiedAt),
            type: data.type,
            typeMeta: data.typeMeta,
            status: data.status,
        };
        if (pointsAction.type === "purchase" &&
            data.typeMeta &&
            data.typeMeta.purchasedAt) {
            pointsAction.typeMeta.purchasedAt = convertTimestampToLuxonOrDefaultNow(data.typeMeta.purchasedAt);
        }
        assertPointsAction(pointsAction, "load");
        return pointsAction;
    },
});
//# sourceMappingURL=PointsAction.js.map